import type { FaireThemeEntity } from "../../entity_types/theme";

export const artisanal_trial_kits: FaireThemeEntity = {
  token: "artisanal-trial-kits",
  type: "theme",
  name: "Artisanal Trial Kits",
  description: "Low-risk discovery sets and trial-priced products from small-batch brands -- ideal for testing new categories.",
  teaser: "Low-risk discovery sets perfect for rotating pop-up inventory.",
  detail: "Your pop-up business benefits from small-batch and handmade signals with low first-order minimums ($10). Multiple Wholesale Discovery Kits from River Organics align with your browsing behavior for new brand entry points.",
  bgColor: "#D6E0F0",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_mdzwes5fgm",
    "p_g5h3c2by94",
    "p_jpsr5z56rp",
    "p_rvmzmqcxnm",
    "p_4w7a6pw4dz",
    "p_42n546c9et",
    "p_e8b6rxq4x3",
    "p_h7chgnadmg",
    "p_caymsb9trs",
    "p_c8xt39gf83",
    "p_cx7cg8yrkf",
    "p_rwq249729q",
    "p_yuty8d3hca",
    "p_vrp2jmxbp9",
    "p_dzqxhfwz6b",
    "p_kmpy98e5fy",
    "p_b9r6q9pgxk",
    "p_3prhvv97tc",
    "p_guzrc3d4hd",
    "p_t7yvn37bwu",
    "p_s2ya4tycb5",
    "p_dpyp6s7cy3",
    "p_ku9gn8wpfy",
    "p_rw8k679bpz",
    "p_zuujmg5v3y",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
